import { Component, Input } from '@angular/core';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-one-help-theme',
  templateUrl: './one-help-theme.component.html',
  styleUrls: ['./one-help-theme.component.scss']
})
export class OneHelpThemeComponent {
  panelOpenState = false;
  @Input() titleBloc: string;
  @Input() tag;
  constructor(private atInternetService: AtInternetService) { }

  generateTagIfOpen() {
    if (this.panelOpenState) {
      var click = this.getClickXitiName(this.titleBloc)
      this.atInternetService.generateClickAction(
        this.tag,
        click,
        'chevron_ouvert'
      );
    }
  }

  private getClickXitiName(titleBloc: string): string {
    switch (titleBloc) {
      case "claim":
        return "Chevron_Aide_Reclamations";
      case "tracking":
        return "Chevron_Aide_SuiviColis";
      case "delivery-choice":
        return "Chevron_Aide_Reprogrammation";
      case "availability":
        return "Chevron_Aide_DisponibiliteSuivi";
      case "unavailability":
        return "Chevron_Aide_IndisponibiliteErreur";
      default:
        ""
    }
  }
}
